import React, { useState, useMemo, useEffect } from 'react';
import Field from './field';
import { Form, FormField } from './formTypes';
import Button from '@material-ui/core/Button';
import { useTheme } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles';

const validationStatus = (field: FormField, value: any) => {
    const valid = new RegExp(field.validationRegex);
    const hasValue = Boolean(value)
    let isValid = !field.mandatory || (hasValue && field.mandatory)

    if (field.validationRegex)
        isValid = valid.test(value)

    return isValid
}

const calculateFormStatus = (formValues: { [fieldId: string]: any }) => {
    let valid = true;
    for (const [, value] of Object.entries(formValues)) {
        if (!value) {
            valid = false;
            break;
        }
    }
    return valid;
}

interface Props {
    form: Form;
    returnUrl: string;
    submissionsUrl: string;
    successMessage?: string;
    submitText: string;
    submitColor?: string;
};

const FormComponent = ({ form, submissionsUrl, returnUrl, successMessage, submitText, submitColor }: Props) => {
    const theme = useTheme();
    //call api to get nonce
    const [nonce, setNonce] = useState("IX-FORMS-NONCE");
    const [nonceLoaded, setNonceLoaded] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [fieldsDisabled, setFieldsDisabled] = useState(true);
    const fingerprint = "TODO";
    const message = successMessage || "Thank you for your enquiry, we will be in contact soon.";
    const loadNonce = async () => {
        const nonceResult = await fetch(`${submissionsUrl}/nonce`, {
            method: "POST", body: JSON.stringify({ fingerprint: fingerprint }), headers: { 'content-type': "application/json" }
        });
        setNonce((await nonceResult.json()).value);
        setNonceLoaded(true);
    }
    useEffect(() => {
        loadNonce();
        setFieldsDisabled(false);
    }, []);

    //todo:noscript

    //TODO: configure these settings
    const formUrl = `${submissionsUrl}/sub?returnUrl=${encodeURIComponent(returnUrl)}`

    let validationState = {};
    let formValuesState = {};
    form.formFields.forEach(field => {
        validationState[field.fieldId] = validationStatus(field, "")
        formValuesState[field.fieldId] = ""
    })


    const [formValid, setFormValid] = useState(calculateFormStatus(formValuesState));
    const [fieldValidation, setFieldValidation] = useState(validationState);
    const [fieldValues, setFieldValues] = useState(formValuesState);

    const fieldChanged = (field, newValue) => {
        const newState = {
            ...fieldValidation,
            [field.fieldId]: validationStatus(field, newValue)
        }
        const newValuesState = {
            ...fieldValues,
            [field.fieldId]: newValue
        }
        const isValid = calculateFormStatus(newState)
        setFieldValidation(newState);
        setFieldValues(newValuesState);
        setFormValid(isValid);
    }
    const canSubmit = useMemo(() => {
        return formValid && nonceLoaded && !submitting && !success;
    }, [formValid, nonceLoaded, submitting, success]);

    const submit = async () => {
        setSubmitting(true);
        //TODO: disable fields while submitting
        try {

            let formValues = {};
            form.formFields.forEach(field => {
                formValues[field.name] = fieldValues[field.fieldId];
            })
            const formSubmission = {
                fingerprint: fingerprint,
                nonce: nonce,
                values: {
                    ...formValues,
                }
            };
            const subResult = await fetch(`${submissionsUrl}/sub`, {
                method: "POST", body: JSON.stringify(formSubmission), headers: { 'content-type': "application/json" }
            });
            //const result = await subResult.json();//TODO: do we need this for anything? maybe a result message?
            //setNonce(().value);
            setSuccess(true);
        } catch (e) {
            //TODO: log/retry/inform user?
            console.error(`Error submitting form`, e);
        }
        setSubmitting(false);
    }

    const getSubmitColour = () => {
        const colour = submitColor ? submitColor : theme.palette.primary.main;
        if (canSubmit)
            return colour;
        else
            return alpha(colour, 0.3);
    };

    return (
        <>
            {form && (
                <form className="form" action={formUrl} method="POST">
                    {/*<h2>{form.name}</h2>*/}
                    {success && (
                        <>
                            <strong>{message}</strong>
                        </>
                    )}
                    {!success && (
                        <>
                            <input type="hidden" name="fingerprint" value={fingerprint} />
                            <input type="hidden" name="nonce" value={nonce} />
                            <input type="hidden" name="returnUrl" value={returnUrl} />
                            {
                                form.formFields.map(field =>
                                    (<Field key={field.fieldId} field={field} value={fieldValues[field.fieldId]} valid={fieldValidation[field.fieldId]} onChanged={fieldChanged} disabled={fieldsDisabled} />)
                                )
                            }

                            <Button variant="contained" style={{ backgroundColor: getSubmitColour(), color: theme.palette.getContrastText(getSubmitColour()), textTransform: "none"}} onClick={submit} disabled={!canSubmit}>
                                {submitText}</Button>
                        </>)}
                </form>
            )}
        </>
    );
}

export default FormComponent;